import { render, staticRenderFns } from "./PublicLeftSide.vue?vue&type=template&id=60ac49a7"
import script from "./PublicLeftSide.vue?vue&type=script&lang=js"
export * from "./PublicLeftSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports